exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".distributionSchedule{padding-left:24px;font-size:16px}#mw.xs mw-newsletter-distribution-data-table table.md-table.md-row-select td.md-cell:nth-child(3),#mw.xs mw-newsletter-distribution-data-table table.md-table.md-row-select th.md-column:nth-child(3){padding:0 24px}.automatedEmptySpace{margin:20px 0 0!important}#distributionBackButton{position:fixed;width:100%;z-index:3!important}#mw-newsletter-distributions-table__content{padding-top:80px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./apps-ts/outputs/src/app/newsletter-distributions/newsletter-distributions.component.css
 ** module id = 41
 ** module chunks = 0 1
 **/